import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";

const getFileTypeFromUrl = (url) => {
  const extension = url.split(".").pop().toLowerCase();
  const mimeTypes = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    pdf: "application/pdf",
  };
  return mimeTypes[extension] || "application/octet-stream";
};

export const useCollectionPointStore = create((set) => ({
  fuelTypes: [],
  fileInputs: {
    collectionPointImageUrl: null,
  },
  filePreviews: {
    collectionPointImageUrl: null,
  },

  handleFileChange: (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      const fileType = file.type;
      set((state) => ({
        fileInputs: { ...state.fileInputs, [fieldName]: file },
        filePreviews: {
          ...state.filePreviews,
          [fieldName]: { file, fileType, fileUrl },
        },
      }));
    }
  },

  resetFileInputs: () => {
    set({
      fileInputs: {
        collectionPointImageUrl: null,
      },
      filePreviews: {
        collectionPointImageUrl: null,
      },
    });
  },
  updateFilePreview: (collectionPointImageUrl) => {
    set((state) => ({
      filePreviews: {
        ...state.filePreviews,
        collectionPointImageUrl: collectionPointImageUrl
          ? {
              fileUrl: collectionPointImageUrl,
              fileType: getFileTypeFromUrl(collectionPointImageUrl),
            }
          : { fileUrl: null, fileType: null },
      },
    }));
  },
}));
